import { Link } from "react-router-dom";
import css from "./HomePage.module.css";

export default function HomePage() {
  return (
    <>
      <section className={css["jumbotron-home"]}>
        <div className="p-5">
          <div className="container-fluid py-5 text-center">
            <div className={css["title-container"]}>
              <h1 className="display-3 fw-light lh-1">
                Museo di Storia Naturale
              </h1>
              <h1 className="display-3 fw-semibold lh-1 mb-4">
                Antonio Orsini
              </h1>
            </div>
            <p className="fs-2">Ascoli Piceno | Italy</p>
            <div
              className="d-flex flex-column flex-md-row gap-3 justify-content-center"
              style={{ margin: "40px auto 60px" }}
            >
              <Link
                to="/museo"
                className="btn btn-primary btn-lg bd-btn-lg fw-semibold"
              >
                Scopri
              </Link>
              <Link
                to="https://www.museicartierapapale.it/visita/"
                target="_blank"
                className="btn btn-secondary btn-lg bd-btn-lg fw-semibold"
              >
                Visita
              </Link>
            </div>
          </div>
        </div>
        <div className={css["freepik-quote-container"]}>
          <p>
            Image by{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.freepik.com/free-vector/green-watercolor-leaves-background_13295055.htm#query=watercolor%20eucalyptus&position=17&from_view=keyword&track=ais"
            >
              Freepik
            </a>
          </p>
        </div>
      </section>
    </>
  );
}
